import React from "react";

class Page7 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 7) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              It’s great that you have an idea of what you want
                              with regards to your career, however it is
                              important to be open to chance events.
                            </li>
                            <br />
                            <li>
                              Get out there, meet students, employers and keep
                              on top of sector developments.
                            </li>
                            <br />
                            <li>
                              Constantly seek to feed your curiosity by
                              exploring new opportunities, and who knows what
                              you'll end up doing!
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page7;
